// src/config.js

const isProd = process.env.NODE_ENV === 'production';
const isBrowser = typeof window !== 'undefined';

function trimTrailingSlash(value) {
  return String(value || '')
    .trim()
    .replace(/\/+$/, '');
}

function getBrowserOrigin() {
  return isBrowser ? window.location.origin : '';
}

function getConfiguredUrl(primary, fallback, devDefault) {
  const configured = trimTrailingSlash(primary || fallback);
  if (configured) return configured;

  if (!isProd) return devDefault;

  return trimTrailingSlash(getBrowserOrigin());
}

function splitCsv(value, fallback = '') {
  return String(value || fallback)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export const config = {
  API_BASE_URL: getConfiguredUrl(
    process.env.REACT_APP_API_BASE_URL,
    process.env.REACT_APP_API_URL,
    'http://localhost:3001'
  ),

  WS_BASE_URL: getConfiguredUrl(
    process.env.REACT_APP_WS_BASE_URL,
    process.env.REACT_APP_WS_URL,
    'http://localhost:3001'
  ),

  ENABLE_TOKEN_EXCHANGE: process.env.REACT_APP_ENABLE_TOKEN_EXCHANGE === 'true',

  ALLOW_GUESTS: process.env.REACT_APP_ALLOW_GUESTS === 'true',

  ALLOW_URL_TOKEN: process.env.REACT_APP_ALLOW_URL_TOKEN === 'true' || !isProd,

  CTRLG_LOGIN_URL: process.env.REACT_APP_CTRLG_LOGIN_URL || 'https://ctrlg.gg/login',

  ANALYTICS_ENDPOINT: process.env.REACT_APP_ANALYTICS_ENDPOINT || '',

  PARENT_ORIGINS: splitCsv(
    process.env.REACT_APP_PARENT_ORIGINS,
    isProd ? '' : 'http://localhost:5500'
  ),
};

if (isBrowser && isProd) {
  const usingSameOriginFallback =
    config.API_BASE_URL === getBrowserOrigin() &&
    !process.env.REACT_APP_API_BASE_URL &&
    !process.env.REACT_APP_API_URL;

  if (usingSameOriginFallback) {
    // eslint-disable-next-line no-console
    console.warn(
      '[config] Missing REACT_APP_API_URL/REACT_APP_API_BASE_URL in production. Falling back to same-origin.'
    );
  }
}

export default config;
